import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { from, Observable, switchMap } from 'rxjs';
import { environment } from '../environments/environment';
import { UserService } from './user.service';
import { ReplayProtectionService } from './replay-protection.service';

@Injectable({
  providedIn: 'root'
})
export class NavLinksService {
  private apiUrl = environment.apiUrl;
  private token: string;
  constructor(private http: HttpClient, private userService: UserService, private replayProtection: ReplayProtectionService) {
    this.token = this.userService.getAccessToken();
  }

  getMenuBasedOnRole(Role: string, CustomerId: number, UserId: number): Observable<HttpResponse<any>> {
    const url = `${this.apiUrl}/api/MenuHandler/GetMenuBasedOnRole?Role=${Role}&CustomerId=${CustomerId}&UserId=${UserId}`;
    return from(
      this.replayProtection.getReadHeaders('GetMenuBasedOnRole', String(this.userService.getUserId()))
    ).pipe(
      switchMap(replayHeaders => {
        const headers = new HttpHeaders({ 'Authorization': `Bearer ${this.userService.getAccessToken()}`, ...replayHeaders });
        return this.http.get(url, { headers: headers, observe: 'response' });
      })
    );
  }
}
